<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2021-08-19 18:20:49
 * @LastEditTime: 2022-11-02 16:15:10
 * @Description: 泵车派发
 * @Param:
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\pumpTruckDistribution\index.vue
 -->

<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonTableStyles pumpTruckDistribution">
            <van-nav-bar
                title="泵车派发"
                left-text="首页"
                left-arrow
                @click-left="swiperright"
                @click-right="stationShow = true"
            >
                <template #right>
                    <span class="station">
                        {{ stationName }}
                        <i class="iconfont iconjiantouxia"></i>
                    </span>
                </template>
            </van-nav-bar>
            <section>
                <van-search
                    v-model="keywords"
                    placeholder="请输入任务编号/标号/工程名称进行查询"
                    @search="search"
                ></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        :finished="finished"
                        finished-text="没有更多了!"
                        @load="onLoad"
                        :immediate-check="false"
                    >
                        <ul class="list">
                            <template v-for="(item,index) in listData">
                                <li :key="`list_${index}`" @click="addPumpTruckCompany(item)">
                                    <div class="engineeringInfo">
                                        <h4 class="engineeringInfo_header">
                                            <span class="headerName">任务编号:{{ item.task_number }}</span>
                                        </h4>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                <span>要求到货时间：{{ item.arrival_time }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_2.png" alt="">
                                                <span>工程名称：{{ item.project_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                                <span>工程地址：{{ item.project_address }}</span>
                                            </p>
                                            <p>
                                                <van-row>
                                                    <van-col span="12">
                                                        <img src="@/assets/images/icons/icon_30.png" alt="">
                                                        <span>订单方量：{{ item.plan_quantity }}</span>
                                                    </van-col>
                                                    <van-col span="12">
                                                        <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                        <span>标号：{{ item.strength_grade_name }}</span>
                                                    </van-col>
                                                </van-row>
                                            </p>
                                            <p>
                                                <van-row>
                                                    <van-col span="12">
                                                        <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                                        <span>施工部位：{{ item.place_name }}</span>
                                                    </van-col>
                                                    <van-col span="12">
                                                        <img src="@/assets/images/icons/icon_16.png" alt="">
                                                        <span>坍落度：{{ item.slump_name }}</span>
                                                    </van-col>
                                                </van-row>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_4.png" alt="">
                                                <span>施工描述：{{ item.place_detail }}</span>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
            <van-popup v-model="stationShow" position="bottom">
                <van-picker
                    title="选择场站"
                    show-toolbar
                    :columns="stationData"
                    value-key="mixstation_name"
                    @confirm="onConfirmStation"
                    @cancel="stationShow = false"
                ></van-picker>
            </van-popup>
        </div>
    </v-touch>
</template>
<script>
export default {
    name: 'pump-truck-distribution',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'pump-truck-distribution');
        }
        next();
    },
    props: {},
    data() {
        return {
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否已加载完所有数据
            finished: false,
            // 分页
            pageindex: 1,
            // 列表总条数
            total: 0,
            // 列表数据
            listData: [],
            // 搜索关键词
            keywords: '',
            // 场站
            stationID: '',
            stationName: '',
            stationData: [],
            stationShow: false,
        };
    },
    computed: {},
    watch: {},
    async created() {
        this.stationData = await this.getStationData();
        this.stationName = this.stationData[0].mixstation_name;
        this.stationID = this.stationData[0].mixstation_code;
        await this.gitListData();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        search() {
            this.onRefresh();
        },
        // 下拉刷新
        onRefresh() {
            this.pageindex = 1;
            this.listData = [];
            this.gitListData();
        },
        // 上拉加载更多
        onLoad() {
            this.pageindex++;
            this.gitListData();
        },
        // 确认场站
        onConfirmStation(value) {
            this.stationName = value.mixstation_name;
            this.stationID = value.mixstation_code;
            this.onRefresh();
            this.stationShow = false;
        },

        // 跳转添加泵车页
        addPumpTruckCompany(row) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'addPumpTruckCompany',
                params: {
                    item: row,
                },
            });
        },


        // 获取列表数据
        async gitListData() {
            const res = await this.gitListDataRequest();
            if (res.data.length > 0) {
                this.total = res.total;
                if (this.listData.length < 1 ) {
                    this.listData = res.data;
                    this.finished = false;
                } else {
                    this.listData.push(...res.data);
                }
                if (this.listData.length === this.total) {
                    this.finished = true;
                }
            } else {
                this.finished = true;
            }
            this.isLoading = false;
            this.isUpLoading = false;
            this.$forceUpdate();
        },

        // 获取场站数据
        getStationData() {
            return this.$axios.$get('/interfaceApi/production/mixstation/mixstation', { defEx: true });
        },

        // 获取列表数据请求
        gitListDataRequest() {
            let search = this.keywords;
            if (this.keywords === '') {
                search = '-';
            } else {
                search = this.keywords;
            }
            // eslint-disable-next-line max-len
            return this.$axios.$get(`/interfaceApi/production/producttask/pumptruckdistribute/${this.stationID}/${search}/${this.pageindex}/3`, { defEx: true });
        },
    },
};
</script>
<style lang="stylus" scoped>
.pumpTruckDistribution
    height 100%
    .van-nav-bar
        .station
            font-size 14rpx
            color #fff
            .iconfont
                font-size 12rpx
    section
        height calc(100% - 45rpx)
        overflow: hidden;
        background: #f0f0f0;
        .van-pull-refresh
            height calc(100% - 40rpx)
            overflow scroll
            -webkit-overflow-scrolling touch
            .van-pull-refresh__track
                height 100%
            .van-list
                height 100%
                background #f0f0f0
            .no-data
                text-align center
                font-size 14rpx
                color #969799
                padding-top 20rpx
</style>